import { Form } from 'antd';
import { useWhPerformanceFiltersStore } from 'shared/stores/use-wh-performance-filters';
import { transformAndSetFilters } from 'shared/utils/filters/transform-and-set-filters';
import { StatisticsDateRangePicker } from 'components/statistics/statistics-date-range-picker';

export const WhPerformanceFilters = () => {
  const { filters, setFilters } = useWhPerformanceFiltersStore();
  const [form] = Form.useForm();

  const handleSuccess = () => {
    transformAndSetFilters(form, setFilters);
  };

  return (
    <Form form={form} name='wh-performance-filter' layout='horizontal' initialValues={filters}>
      <StatisticsDateRangePicker handleSuccess={handleSuccess} />
    </Form>
  );
};
